module.exports = {"TXTCLI_Select_All":{"id":"TXTCLI_Select_All","defaultMessage":"Sélectionner tout","track":"Select All"}}